import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import InputDefault from "../../components/Form/InputDefault";

import styles from './styles';

const RandomKeyPix = () => {
    const [randomKey, setRandomKey] = useState('');

    return (
        <>
            <HeaderDefault title={<FormattedMessage id='randomKeyPix.headerChaveAleatoria'/>} />

            <View style={styles.container}>
                <View style={styles.contentInput}>
                    <FormattedMessage id='randomKeyPix.placeholderChaveAleatoria'>
                     {placeholder =>   
                    <InputDefault
                        value={randomKey}
                        onValueChange={(value) => setRandomKey(value)}
                        placeholder={placeholder}
                    />}
                    </FormattedMessage>
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='randomKeyPix.txtValorTransferencia'/></Text>
                    <Text><FormattedMessage id='randomKeyPix.txtValorTransferenciaBrl'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='randomKeyPix.txtMoeda'/></Text>
                    <Text><FormattedMessage id='randomKeyPix.txtGpxToken'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='randomKeyPix.txtValorDoDia'/></Text>
                    <Text><FormattedMessage id='randomKeyPix.txtValorDoDiaGpx'/></Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}><FormattedMessage id='randomKeyPix.txtRecebedor'/></Text>
                    <Text><FormattedMessage id='randomKeyPix.txtNome'/></Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={<FormattedMessage id='randomKeyPix.btnContinuar'/>} titlePage={<FormattedMessage id='randomKeyPix.btnContinuaTransferencia'/>} />
        </>
    );
}

export default RandomKeyPix;